
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherItemDetailsDialog extends Common.GridEditorDialog<GiftVoucherItemDetailsRow> {
        protected getFormKey() { return GiftVoucherItemDetailsForm.formKey; }
        //protected getIdProperty() { return GiftVoucherItemDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return GiftVoucherItemDetailsRow.localTextPrefix; }
        //protected getNameProperty() { return GiftVoucherItemDetailsRow.nameProperty; }
        //protected getService() { return GiftVoucherItemDetailsService.baseUrl; }
        //protected getDeletePermission() { return GiftVoucherItemDetailsRow.deletePermission; }
        //protected getInsertPermission() { return GiftVoucherItemDetailsRow.insertPermission; }
        //protected getUpdatePermission() { return GiftVoucherItemDetailsRow.updatePermission; }

        protected form = new GiftVoucherItemDetailsForm(this.idPrefix);
        
    }
}